import React from 'react';
import Trial from '../../../sections/Bookfreetrial/Trial';
import Footer from '../../../sections/Footer/Footer';
import Header from '../../../sections/Header/Header';
import CoursesPicContQT from '../../../sections/TitleBgCourses/CoursesPicContQT/CoursesPicContQT';
import TitleBgCoursesQT from '../../../sections/TitleBgCourses/TitlepicCourses/TitleBgCoursesQT/TitleBgCoursesQT';

const CoursesQT = ()=>{
    return(
        <div>
            <Header/>
           <TitleBgCoursesQT/>
           <CoursesPicContQT/>
            <Trial/>
            <Footer/>
        </div>
    )
}

export default CoursesQT;